"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Rendered height taking into account paddings, font-sizes and line-height
exports.height = 36;
exports.width = 360;
exports.iconBoxSize = exports.height; // Fit icons into the square with the side of the input height
//# sourceMappingURL=Input.constants.js.map